import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = true;

const slice = createSlice({
  name: '$loyaltyEnableSmsVerification',
  initialState,
  reducers: {
    setLoyaltyEnableSmsVerification(state, action: PayloadAction<boolean>) {
      return Boolean(action.payload);
    },
  },
});

export const { setLoyaltyEnableSmsVerification } = slice.actions;
export default slice.reducer;
